module.exports = __webpack_public_path__ + "static/media/softwone_logo.e95bc0e5.svg";